package br.com.texeratx.boardgametimeapp.core.active_match

import kotlinx.browser.localStorage
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json

private const val KEY_SNAPSHOT = "active_match_snapshot_json"

class JsActiveMatchStorage : ActiveMatchStorage {

    override suspend fun save(snapshot: ActiveMatchSnapshot?) {
        if (snapshot == null) {
            clear()
            return
        }
        val json = Json.encodeToString(snapshot)
        localStorage.setItem(KEY_SNAPSHOT, json)
    }

    override suspend fun load(): ActiveMatchSnapshot? {
        val json = localStorage.getItem(KEY_SNAPSHOT) ?: return null
        return try {
            Json.decodeFromString<ActiveMatchSnapshot>(json)
        } catch (_: Exception) {
            null
        }
    }

    override suspend fun clear() {
        localStorage.removeItem(KEY_SNAPSHOT)
    }
}

actual fun getPlatformActiveMatchStorage(): ActiveMatchStorage =
    JsActiveMatchStorage()
